export const SCROLL_THRESHOLD = { mobile: 120, desktop: 150 };
export const TABLET_BREAKPOINT = 768;
export const ROUND_LINKS = ['V75', 'V86', 'V64', 'GS75', 'V65', 'V4'];
